import { cmxURL } from '../endpoints';
import PromiseCache from '../utils/promise-cache';
import FetchWithAuth from '../utils/fetch-with-auth';
const DEFAULT_LOCALE = 'en-US';
function CMXService(authState) {
  const fetch = new FetchWithAuth(authState);
  const cache = new PromiseCache(authState);
  async function getBundle(bundleName, locales) {
    return await cache(`getBundle:${bundleName}:${locales.join(':')}`, async () => {
      const res = await fetch(`${cmxURL}/bundle/${encodeURIComponent(bundleName)}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          locales
        })
      });
      const data = await res.json();
      if (res.ok) {
        return data;
      } else {
        throw data;
      }
    })();
  }
  async function getMergedBundle(bundleNames, locale = DEFAULT_LOCALE) {
    const bundleData = await Promise.all(bundleNames.map(bundleName => getBundle(bundleName, [locale])));
    let mergedBundle = bundleData[0].bundles[locale];
    for (let i = 1; i < bundleData.length; i++) {
      mergedBundle = {
        ...mergedBundle,
        ...bundleData[i].bundles[locale]
      };
    }
    return mergedBundle;
  }
  async function getStringsWithAttributes(bundleName, locale = DEFAULT_LOCALE, keys = []) {
    return await cache(`getStringsWithAttributes:${bundleName}:${locale}`, async () => {
      const res = await fetch(`${cmxURL}/projects/${encodeURIComponent(bundleName)}/locales/${locale}/attributes`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          keys
        })
      });
      const data = await res.json();
      if (res.ok) {
        return data;
      } else {
        throw data;
      }
    })();
  }
  return {
    getBundle: getMergedBundle,
    getStringsWithAttributes
  };
}
export default CMXService;
//# sourceMappingURL=cmx.js.map